import React from "react";

import "./index.css";
import emailImg from "../../assets/icon_mail.png";
import checkImg from "../../assets/icon_check.svg";
import closeImg from "../../assets/icon_close.svg";
import checkCirleGreeImg from "../../assets/icon_check_circle.png";
import warningImg from "../../assets/badge_warning_thumbnail.png";

export const VerifyEmail = ({ verifyRes, trans, verifyMes, pinReset }) => {
  return (
    <div className="main_body">
      <div className="img_cont">
        <img src={emailImg} className="email_img" alt="email" />
        {verifyRes ? (
          <img src={checkImg} className="check_img" alt="check" />
        ) : (
          <img src={closeImg} className="check_img" alt="close" />
        )}
      </div>
      <div className="text_light">{verifyMes}</div>
      {pinReset ? (
        ""
      ) : (
        <div className="text_gray">
          {verifyRes ? trans.email_success_title : ""}
        </div>
      )}
    </div>
  );
};

export const VerifyPassword = ({ trans, verifyMes, verifyRes }) => {
  return (
    <div className="main_body">
      <div className="img_cont">
        {verifyRes ? (
          <img src={checkCirleGreeImg} className="email_img" alt="ok" />
        ) : (
          <img src={warningImg} className="email_img" alt="false" />
        )}
      </div>
      <div className="text_light">{verifyMes}</div>
      <div className="text_gray">
        {verifyRes ? trans.reset_succcess_title : ""}
      </div>
    </div>
  );
};
